import { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import LeftContent from "components/authentication/LeftContent";
import SignUpForm, {
    SignUpFormValues,
} from "components/authentication/SignUp/SignUpForm";
import VerifyUserForm from "components/authentication/VerifyUserForm";
import VerificationSuccess from "components/authentication/VerificationSuccess";
import Spinner from "components/common/Spinner";
import { APP_CONFIG } from "config/appConfig";
import { useAuth } from "hooks/useAuth";
import keycloakService from "service/keycloakService";

const SignUp = () => {
    const history = useHistory();
    const { signOut } = useAuth();
    const [email, setEmail] = useState("");
    const [emailSentSuccess, setEmailSentSuccess] = useState(false);
    const [isRegisteredSuccessfully, setIsRegisteredSuccessfully] =
        useState(false);
    const [signInLoading, setSignInLoading] = useState(false);

    const isOnPremAuth =
        APP_CONFIG.APP_IS_ONPREM;

    // Check if user is authenticated with Keycloak on mount and get their email
    useEffect(() => {
        const checkKeycloakAuth = async () => {
            if (isOnPremAuth) {
                const authenticated = keycloakService.isAuthenticated();

                if (authenticated) {
                    const userProfile = await keycloakService.getUserProfile();
                    if (userProfile?.email) {
                        setEmail(userProfile.email);
                    }
                }
            }
        };
        checkKeycloakAuth();
    }, [isOnPremAuth]);

    const onVerifySuccess = () => {
        setIsRegisteredSuccessfully(true);
    };

    const onSignUpSuccess = async ({ email }: SignUpFormValues) => {
        setEmail(email);
        setEmailSentSuccess(true);

        if (isOnPremAuth) {
            setIsRegisteredSuccessfully(true);
        }
    };

    const handleVerificationSignIn = async () => {
        setSignInLoading(true);

        if (isOnPremAuth) {
            const delaySeconds = APP_CONFIG.APP_SIGNUP_LOGIN_DELAY_SECONDS;
            if (delaySeconds > 0) {
                await new Promise((resolve) =>
                    setTimeout(resolve, delaySeconds * 1000)
                );
            }
            await signOut();
            return;
        }

        history.push("/");
    };

    let rightContent = <SignUpForm onSuccess={onSignUpSuccess} />;
    // Show verification steps for COGNITO and LOCAL (same flow)
    if (!isOnPremAuth) {
        if (emailSentSuccess) {
            rightContent = (
                <VerifyUserForm onSuccess={onVerifySuccess} email={email} />
            );
        }
    }

    if (isRegisteredSuccessfully) {
        rightContent = (
            <VerificationSuccess onSignIn={handleVerificationSignIn} />
        );
    }

    if (signInLoading) {
        return <Spinner />;
    }

    return (
        <section>
            <Container fluid>
                <Row className="flex-row-reverse">
                    {rightContent}

                    <LeftContent />
                </Row>
            </Container>
        </section>
    );
};

export default SignUp;
